define('webcomponents', ['knockout'], function (ko) {
	ko.components.register('unsupported-browser', {
		require: 'v3/Common/Components/UnsupportedBrowser/UnsupportedBrowser.Component',
		synchronous: true
	});

	ko.components.register('read-speaker', {
		require: 'v3/Common/Components/ReadSpeaker/ReadSpeaker.Component',
		synchronous: true
	});

	ko.components.register('main-menu', {
		require: 'v3/Common/Components/MainMenu/MainMenu.Component',
		synchronous: true
	});

	ko.components.register('sub-menu', {
		require: 'v3/Common/Components/SubMenu/SubMenu.Component',
		synchronous: true
	});

	ko.components.register('search-box', {
		require: 'v3/Common/Components/Search/SearchBox.Component',
		synchronous: true
	});

	ko.components.register('search', {
		require: 'v3/Common/Components/Search/Search.Component',
		synchronous: true
	});

	ko.components.register('file-upload', {
		require: 'v3/Common/Components/FileUpload/FileUpload.Component',
		synchronous: true
	});

	// Ability chart
	ko.components.register('ability-legend', {
		require: 'v3/Pages/AbilityGraph/Components/Legend/Legend.Component',
		synchronous: true
	});

	ko.components.register('ability-toggle', {
		require: 'v3/Pages/AbilityGraph/Components/Toggle/Toggle.Component',
		synchronous: true
	});

	ko.components.register('ability-filter', {
		require: 'v3/Pages/AbilityGraph/Components/Filter/Filter.Component',
		synchronous: true
	});

	ko.components.register('ability-chart', {
		require: 'v3/Common/Components/RainbowChart/RainbowChart.Component',
		synchronous: true
	});

	// TODO #19173 Deprecated. Please use subject-groups-dropdown instead
	ko.components.register('subjects-dropdown', {
		require: 'v3/Common/Components/SubjectsDropdown/SubjectsDropdown.Component',
		synchronous: true
	});

	ko.components.register('subject-groups-dropdown', {
		require: 'v3/Common/Components/SubjectGroupsDropdown/SubjectGroupsDropdown.Component',
		synchronous: true
	});

	ko.components.register('timeperiod-dropdown', {
		require: 'v3/Common/Components/TimePeriodDropdown/TimePeriodDropdown.Component',
		synchronous: true
	});

	ko.components.register('pupil-dropdown', {
		require: 'v3/Common/Components/PupilDropdown/PupilDropdown.Component',
		synchronous: true
	});

	ko.components.register('ability-growth-arrows', {
		require: 'v3/Common/Components/AbilityGrowthArrows/AbilityGrowthArrows.Component',
		synchronous: true
	});

	ko.components.register('ability-percentile-bar', {
		require: 'v3/Common/Components/AbilityPercentileBar/AbilityPercentileBar.Component',
		synchronous: true
	});

	ko.components.register('nav-back-button', {
		require: 'v3/Common/Components/NavBackButton/NavBackButton.Component',
		synchronous: true
	});

	ko.components.register('dropdown', {
		require: 'v3/Common/Components/Dropdown/Dropdown.Component',
		synchronous: true
	});

	ko.components.register('selection-bar', {
		require: 'v3/Common/Components/SelectionBar/SelectionBar.Component',
		synchronous: true
	});

	ko.components.register('selection-bar-overview', {
		require: 'v3/Common/Components/SelectionBar/SelectionOverview.Component',
		synchronous: true
	});

	ko.components.register('sortable-column-header', {
		require: 'v3/Common/Components/SortableColumnHeader/SortableColumnHeader.Component',
		synchronous: true
	});

	ko.components.register('check-class-grid', {
		require: 'v3/Pages/Check/Components/CheckClassGrid/CheckClassGrid.Component',
		synchronous: true
	});

	ko.components.register('check-pupil-grid', {
		require: 'v3/Pages/Check/Components/CheckPupilGrid/CheckPupilGrid.Component',
		synchronous: true
	});

	ko.components.register('resizeable-columntext', {
		require: 'v3/Common/Components/ResizeableColumntext/ResizeableColumntext.Component',
		synchronous: true
	});

	ko.components.register('collapsible-panel', {
		require: 'v3/Common/Components/CollapsiblePanel/CollapsiblePanel.Component',
		synchronous: true
	});

	ko.components.register('grid', {
		require: 'v3/Common/Components/Grid/Grid.Component',
		synchronous: true
	});

	ko.components.register('wow-progress-bar', {
		require: 'v3/Pages/WayOfWork/Components/WowProgressBar/WowProgressBar.Component',
		synchronous: true
	});

	ko.components.register('wow-dropdown', {
		require: 'v3/Pages/WayOfWork/Components/WowDropdown/WowDropdown.Component',
		synchronous: true
	});

	ko.components.register('wow-card', {
		require: 'v3/Pages/WayOfWork/Components/WowCard/WowCard.Component',
		synchronous: true
	});

	ko.components.register('class-growth-info-block', {
		require: 'v3/Pages/SchoolReport/Components/ClassGrowthInfoBlock/ClassGrowthInfoBlock.Component',
		synchronous: true
	});
});

define("E:\BuildAgent\work\c0a7f951091ff0f7\SnappetWeb\NewSnappetDashboard\Areas\V3\Source\Js\Config\webcomponents.js", function(){});

